const {
  // 文件传输
  VUE_APP_FILE_DOWNLOAD: fileDownload
} = process.env
export default {
  file: { // 文件传输
    download: fileDownload
  },
  role: {
    role_1: {
      id: '',
      name: '街道议政员'
    }
  }
}
